async function fetchProductAndUpdateButton() {
  const productUrl = window.productUrl;
  try {
    const response = await fetch(`${productUrl}.json`);
    const data = await response.json();

    if (response.ok) {
      const variants = data.product.variants;

      const selectedVariant = variants.find((variant) =>
        window.location.href.includes(`variant=${variant.id}`)
      );

      if (selectedVariant) {
        const wishlistButton = document.querySelector("wishlist-button");
        wishlistButton.dataset.title = `${data.product.title} ${selectedVariant.title}`;
        wishlistButton.dataset.id = selectedVariant.id;
        wishlistButton.dataset.price = selectedVariant.price.toString();
        wishlistButton.dataset.url = productUrl;
        wishlistButton.dataset.handle = data.product.handle;
        wishlistButton.dataset.images = selectedVariant.featured_image.src;
        wishlistButton.dataset.cart = true ? "true" : "false";

        let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
        let wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
        let exists = wishlistItems.some((item) => item.id == selectedVariant.id);

        if (exists) {
          wishlistButton.classList.add("is-animating");
        } else {
          wishlistButton.classList.remove("is-animating");
        }
      }
    } else {
      console.log(response);
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.log(error);
  } finally {
    document.dispatchEvent(new Event("wishlist-changed"));
  }
}

async function removeItemFromCart(variantId) {
  if (!variantId) {
    return;
  }

  try {
    const response = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        updates: {
          [variantId]: 0,
        },
      }),
    });

    if (response.ok) {
      await response.json();
    }

    if (!response.ok) {
      console.log(response);
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.log(error);
  } finally {
    document.dispatchEvent(new Event("wishlist-changed"));
  }
}

async function AddToCart(formData) {
  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    if (response.ok) {
      await response.json();
    }

    if (!response.ok) {
      console.log(response);
      throw new Error("Network response was not ok");
    }
  } catch (error) {
    console.log(error);
  } finally {
    document.dispatchEvent(
      new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
    );
    document.dispatchEvent(
      new CustomEvent("theme:open-cart-drawer", { bubbles: true, cancelable: false })
    );
    document.dispatchEvent(new Event("wishlist-changed"));
  }
}

async function renderWishList(wishlistItems) {
  let itemHTML = "";

  for (let item of wishlistItems) {
    let handle = item.handle;
    let productUrl = `/products/${handle}`;

    const productResponse = await fetch(`${productUrl}.js`);
    const productData = await productResponse.json();
    const variants = productData.variants;

    const currentVariantId = Number(item.id);
    const currentVariant = variants.find((v) => v.id === currentVariantId);
    const currentVariantTitle = currentVariant ? currentVariant.title : "";
    const productJson = item.productjson;

    console.log("item", item);

    // 'preorderinfo' is a string such as:
    // "[{'54963773964661': 'true'},{'54963773997429': 'true'}, ...]"
    // We want it as an array of objects like:
    // [{ id: 54963773964661, preorder: true }, { id: 54963773997429, preorder: true }, ...]
    const preorderInfo = item.preorderinfo;
    let preorderInfoArray;
    if (preorderInfo !== "[]" && preorderInfo !== "" && preorderInfo != null) {
      preorderInfoArray = preorderInfo
        .replace(/[\[\]{}']/g, "")
        .split(",")
        .map((entry) => {
          const [id, preorder] = entry.split(":");
          const preOrderValue = preorder.trim() === "true";
          return { id: Number(id), preorder: preOrderValue };
        });
    }

    // Check if the current variant is preorder
    const currentVariantIsPreoder = preorderInfoArray
      ? preorderInfoArray.find((entry) => entry.id === currentVariantId && entry.preorder)
      : false;
    const currentVariantIsAvailable = currentVariant ? currentVariant.available : false;

    console.log("variants", variants);
    let variantListItems = "";
    variants.forEach((variant) => {
      const variantIdNum = Number(variant.id);
      const isPreOrder = preorderInfoArray
        ? preorderInfoArray.find((entry) => entry.id === variantIdNum && entry.preorder)
        : false;
      const isAvailable = variant.available;
      console.log("variant is available", isAvailable);

      variantListItems += `
        <li
          class="variant-item ${variantIdNum === currentVariantId ? "selected" : ""}"
          data-variant-id="${variantIdNum}"
          data-available="${isAvailable}"
        >
          <span style="font-weight:500; ${!isAvailable ? "color:darkgray;" : ""}">
            ${variant.title}
          </span>
          ${isPreOrder ? `<span style="text-align:right;">Forudbestil</span>` : ""}
          ${!isAvailable ? `<span style="text-decoration:underline;text-align:right;">Tilmeld venteliste</span>` : ""} 
        </li>
        ${
          !isAvailable
            ? `<a href="#" class="BIS_trigger tw-hidden" data-product-data='${productJson}' data-variant-id="${variant.id}">123</a>`
            : ""
        }
      `;
    });

    const customDropdownHTML = `
      <div class="custom-dropdown wishlist_variant_picker">
        <div class="selected-variant">
            <span style="font-weight:500;">${currentVariantTitle}</span>
            ${currentVariantIsPreoder ? `<span style="text-align:right;">Forudbestil</span>` : ""}
            ${!currentVariantIsAvailable ? `<span style="text-decoration:underline;text-align:right;">Tilmeld venteliste</span>` : ""}          
        </div>
        <ul class="variant-list" style="display: none;">
          ${variantListItems}
        </ul>
      </div>
    `;

    let status = await getProductData(productUrl, currentVariantId);
    const removeTextData = document
      .querySelector(".wishlist_element_wrapper")
      .getAttribute("data-remove-text");
    const addToCartTextData = document
      .querySelector(".wishlist_element_wrapper")
      .getAttribute("data-add-to-cart-text");
    const soldOutTextData = document
      .querySelector(".wishlist_element_wrapper")
      .getAttribute("data-sold-out-text");

    let availability = status ? "" : "disabled";
    let opacity = status ? "" : "tw-opacity-50";
    let color = status ? "tw-bg-[#196450]" : "tw-bg-[#6b6b6b]";

    const waitlistLabel = !status
      ? `<span class="wishlist_waite_badge product-label product-label--sale">
          <img height="55" width="55" loading="lazy" src="//fashionbystrand.com/cdn/shop/t/117/assets/tilmeld-venteliste.png?v=7240073107463983851741353376" alt="Tilmeld venteliste">  
        </span>`
      : "";

    const comparePriceHtml = item.compare_at_price
      ? `<span class="product-price__item product-price__compare theme-money">${item.compare_at_price}</span>`
      : "";

    const saleLabelText = item.salelabeltext
      ? `<span class="wishlist_sale_badge product-label product-label--sale ${
          item.productlabel ? "!tw-top-[40px]" : ""
        }"><span>${item.salelabeltext}</span></span>`
      : "";

    const showPreOrderLabel =
      item.preorderbadge === "true"
        ? `<span class="product-price__item price-label price-label--preorder !tw-left-[10px] !tw-top-[10px]">${item.preordertext}</span>`
        : "";

    const productLabel = item.productlabel
      ? `<span class="wishlist_product_label product-label product-label--meta">
          <span>${item.productlabel}</span>
          </span>`
      : "";

    itemHTML += `
      <div data-id="${item.id}" data-handle="${item.handle}" class="wishlist-item">
        <div class="wishlist-item-info wishlist_item_info">
          <div class="wishlist_item_image_wrapper">
            <a class="wishlist_image_wrapper" href="${item.url}">
              ${waitlistLabel}
              ${productLabel}
              ${showPreOrderLabel}
              ${saleLabelText}
              <img 
                class="wishlist_item_image ${opacity}" 
                style="--wh-ratio: 1.0;width:100%;" 
                src="${item.images}" 
                alt="${item.title}" 
              />
            </a>
            <div class="wishlist_button_wrapper ${opacity}">
              ${customDropdownHTML}              
              <wishlist-add_to_cart class="wishlist_item_buy_button" data-id="${item.id}">
                <button class="wishlist_add_to_cart_button ${color}" ${availability}>
                  <svg 
                    class="js-go-cart-add-to-cart svgcart" 
                    width="20px" 
                    height="20px" 
                    viewBox="0 0 24 24" 
                    aria-hidden="true"
                  >
                    <g 
                      class="js-go-cart-add-to-cart" 
                      stroke="none" 
                      stroke-width="1" 
                      fill="none" 
                      fill-rule="evenodd"
                    >
                      <path 
                        class="js-go-cart-add-to-cart" 
                        d="M3.5,2.75 C4.87766445,2.75 5.56649668,2.75 5.56649668,2.75 C5.56649668,2.75 6.03257795,7.25 6.96474049,16.25 L19.5,16.25" 
                        stroke="currentColor" 
                        stroke-width="1.5" 
                        stroke-linecap="square"
                      ></path>
                      <path 
                        class="js-go-cart-add-to-cart" 
                        d="M6.22627526,6.67553191 C14.8659742,6.67553191 19.1858237,6.67553191 19.1858237,6.67553191 C19.1858237,6.67553191 18.9160351,8.71453901 18.376458,12.7925532 L7.62925996,13.9095745" 
                        stroke="currentColor" 
                        stroke-width="1.5" 
                        stroke-linecap="square"
                      ></path>
                      <circle 
                        class="js-go-cart-add-to-cart" 
                        stroke="currentColor" 
                        stroke-width="1.25" 
                        cx="8.875" 
                        cy="20.005" 
                        r="1.375"
                      ></circle>
                      <circle 
                        class="js-go-cart-add-to-cart" 
                        stroke="currentColor" 
                        stroke-width="1.25" 
                        cx="17.375" 
                        cy="20.005" 
                        r="1.375"
                      ></circle>
                    </g>
                  </svg>
                </button>
              </wishlist-add_to_cart>
            </div>
          </div>
          <a href="${item.url}" class="${opacity}">
            <div class="product-block__title wishlist_item_title">${item.title}</div>
            <p class="product-price__item tw-m-0 wishlist_item_price product-price__amount theme-money">
              <span>${item.price}</span><span class="product-price__compare theme-money">${comparePriceHtml}</span>
            </p>
          </a>
          <remove-item class="wishlist_remove_item remove-item">
            ${removeTextData}
          </remove-item>
        </div>
      </div>
    `;
  }

  // Attach dropdown event listeners after HTML is in the DOM
  setTimeout(() => {
    attachCustomDropdownListeners();
  }, 0);

  return itemHTML;
}

function attachCustomDropdownListeners() {
  document.querySelectorAll(".custom-dropdown .selected-variant").forEach((selectedEl) => {
    selectedEl.addEventListener("click", () => {
      const variantListEl = selectedEl.nextElementSibling;
      if (variantListEl) {
        variantListEl.style.display =
          variantListEl.style.display === "none" ? "block" : "none";
      }
    });
  });

  document.querySelectorAll(".custom-dropdown .variant-item").forEach((variantEl) => {
    variantEl.addEventListener("click", (e) => {
      if (variantEl.dataset.available === "false") {
        const BISTrigger = variantEl.nextElementSibling;
        if (BISTrigger) {
          e.preventDefault();
          BISTrigger.click();
        }
      }
      const clickedVariantId = variantEl.getAttribute("data-variant-id");
      const innerHTML = variantEl.innerHTML;
      const variantTitle = variantEl.textContent.trim();

      const siblings = variantEl.parentElement.querySelectorAll(".variant-item");
      siblings.forEach((sib) => sib.classList.remove("selected"));
      variantEl.classList.add("selected");

      const selectedVariantEl = variantEl.parentElement.previousElementSibling;
      selectedVariantEl.innerHTML = innerHTML;

      const wishlistItemEl = variantEl.closest(".wishlist-item");
      if (wishlistItemEl) {
        const buyButton = wishlistItemEl.querySelector(".wishlist_item_buy_button");
        if (buyButton) {
          buyButton.setAttribute("data-id", clickedVariantId);
        }
      }

      variantEl.parentElement.style.display = "none";
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  const wishlistModule = document.querySelector(".wishlist-module");

  if (wishlistModule) {
    wishlistModule.addEventListener("change", (event) => {
      const target = event.target;

      if (target.classList.contains("wishlist_variant_picker")) {
        const selectedVariantId = target.value;
        const selectedOption = target.options[target.selectedIndex];

        const wishlistItem = target.closest(".wishlist-item");
        const wishlistButton = wishlistItem.querySelector("wishlist-add_to_cart");
        const wishlistImage = wishlistItem.querySelector(".wishlist_item_image");
        const wishlistPrice = wishlistItem.querySelector(".wishlist_item_price");

        wishlistItem.dataset.id = selectedVariantId;
        wishlistButton.dataset.id = selectedVariantId;
        wishlistImage.src = selectedOption.getAttribute("data-image") || "";
        wishlistPrice.textContent = `${Number(selectedOption.getAttribute("data-price")) / 100} USD`;

        const localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items_smykkeli") || "[]");
        const updatedWishlistItems = localWishlistItems.map((item) => {
          if (item.id == wishlistItem.dataset.id) {
            return {
              ...item,
              id: selectedVariantId,
              price: selectedOption.getAttribute("data-price"),
              compare_at_price: selectedOption.getAttribute("data-compare-at-price"),
            };
          }
          return item;
        });
        localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(updatedWishlistItems));
      }
    });
  }
});

function renderWishlistModule() {
  let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
  let wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];

  let wishlistModule = document.querySelector(".wishlist-module");
  let wishlistSection = document.querySelector(".wishlist-section");

  if (wishlistModule) {
    if (wishlistItems.length > 0) {
      wishlistSection.classList.add("active");
      wishlistModule.classList.remove("active");
    } else {
      wishlistModule.classList.add("active");
      wishlistSection.classList.remove("active");
    }
  }
  document.dispatchEvent(new Event("wishlist-changed"));
}

document.addEventListener("DOMContentLoaded", () => {
  renderWishlistModule();
});

class WishlistCount extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    document.addEventListener("DOMContentLoaded", () => {
      this.updateCount();
    });

    document.addEventListener("wishlist-changed", () => {
      this.updateCount();
    });
  }

  updateCount() {
    let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
    let wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
    this.innerHTML = wishlistItems.length.toString();
  }
}

customElements.define("wishlist-count", WishlistCount);

class WishlistButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.updateButtonState();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.toggleWishlistItem(event);
    });

    let fieldSet = document.querySelector("fieldset");
    if (fieldSet) {
      fieldSet.addEventListener("change", () => {
        fetchProductAndUpdateButton();
      });
    }
  }

  updateButtonState() {
    let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
    if (localWishlistItems) {
      let wishlistItems = JSON.parse(localWishlistItems);
      let attributesObject = Object.assign({}, this.dataset);

      let exists = wishlistItems.some((item) => item.id == attributesObject.id);
      if (exists) {
        this.classList.add("is-animating");

        if (attributesObject.cart === "true") {
          this.style.display = "none";
        }
      } else {
        this.classList.remove("is-animating");

        if (attributesObject.cart === "true") {
          this.style.display = "block";
        }
      }
    }
    document.dispatchEvent(new Event("wishlist-changed"));
  }

  toggleWishlistItem(event) {
    this.classList.add("is-animating");

    let wishlistModuleBox = document.querySelector("#wishlist-module-box");
    let wishlistModuleImg = wishlistModuleBox.querySelector("#wishlist-module-img");
    let wishlistModuleTitle = wishlistModuleBox.querySelector("#wishlist-module-title");
    let wishlistModuleText = wishlistModuleBox.querySelector("#wishlist-module-text");

    const removeFromWishlistTextData = document
      .querySelector(".wishlist-button-text")
      .getAttribute("data-removedText");
    const addToWishlistTextData = document
      .querySelector(".wishlist-button-text")
      .getAttribute("data-addedText");

    wishlistModuleBox.classList.toggle("wishlist_module_alert");
    setTimeout(() => {
      wishlistModuleBox.classList.toggle("wishlist_module_alert");
    }, 1000);

    let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
    let wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
    let attributesObject = Object.assign({}, this.dataset);

    wishlistModuleImg.setAttribute("src", attributesObject.images);
    wishlistModuleTitle.innerHTML = attributesObject.title;

    if (this.dataset.cart === "true") {
      let exists = wishlistItems.some((item) => item.id == attributesObject.id);

      if (!exists) {
        wishlistItems.push(attributesObject);
        localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(wishlistItems));
        wishlistModuleText.innerHTML = removeFromWishlistTextData;

        setTimeout(() => {
          const cartRemoveButton = this.closest(".cart-item").querySelector(".cart-item__remove-button");
          if (cartRemoveButton) {
            cartRemoveButton.click();
          }
        }, 1000);
      }
    } else {
      let exists = wishlistItems.some((item) => item.id == attributesObject.id);
      if (!exists) {
        wishlistItems.push(attributesObject);
        localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(wishlistItems));
        wishlistModuleText.innerHTML = addToWishlistTextData;
        console.log("added to wishlist");
      } else {
        let newWishlistItems = wishlistItems.filter((item) => item.id != attributesObject.id);
        localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(newWishlistItems));
        wishlistModuleText.innerHTML = removeFromWishlistTextData;
        console.log("removed from wishlist");
      }

      this.updateButtonState();
    }
  }
}

customElements.define("wishlist-button", WishlistButton);

class WishlistElementsWrapper extends HTMLElement {
  constructor() {
    super();
    this.url = this.dataset.url;
  }

  async connectedCallback() {
    await this.init();
  }

  async init() {
    let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
    let wishlistItems = localWishlistItems ? JSON.parse(localWishlistItems) : [];
    this.innerHTML = "";
    this.innerHTML = `
        <div class="item-container">
          <div class="custom-grid-container">
          ${await this.getWishlistHtml(wishlistItems)}
          </div>
        </div>
      `;
  }

  getWishlistHtml = async (wishlistItems) => {
    try {
      console.log("wishlistItems", wishlistItems);
      const wishlistProductIds = await Promise.all(
        wishlistItems.map(async (item) => {
          const id = item.productid;
          if (!id) return "";
          return `id:${id}`;
        })
      );

      console.log("wishlistProductIds", wishlistProductIds);

      const batchSize = 20;
      const batches = [];

      for (let i = 0; i < wishlistProductIds.length; i += batchSize) {
        batches.push(wishlistProductIds.slice(i, i + batchSize).join(" OR "));
      }

      const responses = await Promise.all(
        batches.map((batchQuery) =>
          fetch(`${this.url}&q=${batchQuery}`).then((res) => {
            if (!res.ok) throw new Error("Network response was not ok");
            return res.text();
          })
        )
      );

      const template = document.createElement("template");
      const allHtml = responses
        .map((html) => {
          template.innerHTML = html;
          console.log("template", template);
          const wishlistWrapper = template.content.querySelector("wishlist-elements-wrapper");
          return wishlistWrapper
            ? Array.from(wishlistWrapper.children)
                .map((child) => child.outerHTML)
                .join("")
            : "";
        })
        .join("");

      return allHtml;
    } catch (error) {
      console.log(error);
      return "";
    }
  };
}

customElements.define("wishlist-elements-wrapper", WishlistElementsWrapper);

class RemoveItem extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", async (event) => {
      event.preventDefault();
      let localWishlistItems = localStorage.getItem("wishlist_items_smykkeli");
      let wishlistItems = JSON.parse(localWishlistItems);

      let id = this.id;
      console.log("id", id);
      let newWishlistItems = wishlistItems.filter((item) => item.productid != id);

      localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(newWishlistItems));

      document.dispatchEvent(new Event("wishlist-changed"));

      const wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
      wishlistElementsWrapper.innerHTML = "";
      wishlistElementsWrapper.init();
      window.location.reload();
    });
  }
}

customElements.define("remove-item", RemoveItem);

class WishlistAddToCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const addToCartButton = this.querySelector("button");
    addToCartButton.addEventListener("click", async (event) => {
      event.preventDefault();

      const wishlistItem = this.closest(".wishlist-item");
      const buyButton = wishlistItem.querySelector(".wishlist_item_buy_button");

      const selectedVariantId = parseInt(buyButton?.dataset.id || "", 10);

      if (isNaN(selectedVariantId)) {
        console.error("Invalid variant ID selected!");
        return;
      }

      const formData = {
        items: [
          {
            id: selectedVariantId,
            quantity: 1,
          },
        ],
      };

      await AddToCart(formData);

      const localWishlistItems = JSON.parse(localStorage.getItem("wishlist_items_smykkeli") || "[]");
      const updatedWishlistItems = localWishlistItems.filter((item) => item.id !== selectedVariantId);

      localStorage.setItem("wishlist_items_smykkeli", JSON.stringify(updatedWishlistItems));

      const wishlistElementsWrapper = document.querySelector("wishlist-elements-wrapper");
      wishlistElementsWrapper.innerHTML = `
        <div class="item-container">
          <div class="custom-grid-container">
            ${await renderWishList(updatedWishlistItems)}
          </div>
        </div>
      `;

      renderWishlistModule();

      document.dispatchEvent(
        new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
      );
      document.dispatchEvent(
        new CustomEvent("theme:open-cart-drawer", { bubbles: true, cancelable: false })
      );
    });
  }
}

async function getProductData(url, variantId) {
  try {
    const response = await fetch(`${url}.js`);

    if (response.ok) {
      const data = await response.json();
      const variants = data.variants;

      let selectedVariant = variants.filter((variant) => {
        return variant.id == variantId;
      });

      let status = selectedVariant[0].available;
      return status;
    } else {
      console.log(response);
    }
  } catch (error) {
    console.log(error);
  }
}
